import SidePage from '../../../../../../shared/SidePage'
import { IMaintenanceProcess } from '../../../maintenance.types.ts'
import { useState } from 'react'
import ViewMaintenanceProcessSidePageContent from '@/pages/Processes/Maintenance/MaintenanceProcesses/components/MaintenanceProcessSidePage/ViewMaintenanceProcessSidePageContent'
import EditMaintenanceProcessSidePageContent from '@/pages/Processes/Maintenance/MaintenanceProcesses/components/MaintenanceProcessSidePage/EditMaintenanceProcessSidePageContent'

interface IProps {
  onClose: () => void
  onCloseAnimationEnd?: () => void
  open: boolean
  id: IMaintenanceProcess['id']
}

const MaintenanceProcessSidePage = (props: IProps) => {
  const [pageMode, setPageMode] = useState<'view' | 'edit'>('view')

  const renderContent = () => {
    if (pageMode === 'edit') {
      return <EditMaintenanceProcessSidePageContent processId={props.id} onCancel={() => setPageMode('view')} />
    }

    return (
      <ViewMaintenanceProcessSidePageContent
        processId={props.id}
        onEdit={() => setPageMode('edit')}
        onClose={props.onClose}
      />
    )
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} onCloseAnimationEnd={props.onCloseAnimationEnd}>
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.id) return null

  return <MaintenanceProcessSidePage {...props} />
}
